import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
// Dish Tech React
import { actionsServiceCaller } from '@dishtech-react/utils'; // Action Types

import { actionTypes } from '../action-types';
export var registerForm = function registerForm(formKey) {
  return function (dispatch) {
    return Promise.resolve(dispatch({
      payload: {
        formKey: formKey
      },
      type: actionTypes.FORM_REGISTER
    }));
  };
};
export var unregisterForm = function unregisterForm(formKey) {
  return function (dispatch) {
    return Promise.resolve(dispatch({
      payload: {
        formKey: formKey
      },
      type: actionTypes.FORM_UNREGISTER
    }));
  };
};
export var setFieldValue = function setFieldValue(formKey, fieldName, value) {
  return function (dispatch) {
    return Promise.resolve(dispatch({
      payload: {
        fieldName: fieldName,
        formKey: formKey,
        value: value
      },
      type: actionTypes.FORM_SET_FIELD_VALUE
    }));
  };
};
export var setFieldValues = function setFieldValues(formKey, values, resetValues) {
  if (resetValues === void 0) {
    resetValues = true;
  }

  return function (dispatch) {
    return Promise.resolve(dispatch({
      payload: {
        formKey: formKey,
        resetValues: resetValues,
        values: values
      },
      type: actionTypes.FORM_SET_FIELD_VALUES
    }));
  };
};
export var clearFieldValue = function clearFieldValue(formKey, fieldName) {
  return function (dispatch) {
    return Promise.resolve(dispatch({
      payload: {
        fieldName: fieldName,
        formKey: formKey
      },
      type: actionTypes.FORM_CLEAR_FIELD_VALUE
    }));
  };
};
export var setFieldErrors = function setFieldErrors(formKey, fieldName, errors) {
  return function (dispatch) {
    return Promise.resolve(dispatch({
      error: true,
      payload: {
        fieldName: fieldName,
        formKey: formKey,
        errors: errors
      },
      type: actionTypes.FORM_SET_FIELD_ERRORS
    }));
  };
};
export var clearFieldErrors = function clearFieldErrors(formKey, fieldName) {
  return function (dispatch) {
    return Promise.resolve(dispatch({
      payload: {
        fieldName: fieldName,
        formKey: formKey
      },
      type: actionTypes.FORM_CLEAR_FIELD_ERRORS
    }));
  };
};
export var resetForm = function resetForm(formKey) {
  return function (dispatch) {
    return Promise.resolve(dispatch({
      payload: {
        formKey: formKey
      },
      type: actionTypes.FORM_RESET
    }));
  };
};
export var submitForm = function submitForm(serviceConfig, formKey, formValues, id) {
  return function (dispatch) {
    var handleFetched = function handleFetched(jsonResponse) {
      return {
        response: jsonResponse,
        serviceKey: formKey
      };
    };

    var handleError = function handleError(error) {
      return {
        error: error,
        serviceKey: formKey
      };
    };

    var actionParams = {
      handleFetched: handleFetched,
      handleError: handleError,
      serviceConfig: serviceConfig[formKey]
    };
    return dispatch({
      meta: {
        serviceKey: formKey
      },
      payload: actionsServiceCaller(actionParams, formValues, id),
      type: 'SERVICE'
    });
  };
};